const WarningFull = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.83956 2.88136C8.80426 1.2276 11.1938 1.22759 12.1585 2.88136L18.0067 12.907C18.9789 14.5736 17.7768 16.6666 15.8473 16.6666H4.15074C2.22126 16.6666 1.01908 14.5736 1.99129 12.907L7.83956 2.88136ZM9.99984 6.66667C10.4601 6.66667 10.8332 7.03977 10.8332 7.5V10C10.8332 10.4602 10.4601 10.8333 9.99984 10.8333C9.5396 10.8333 9.1665 10.4602 9.1665 10V7.5C9.1665 7.03977 9.5396 6.66667 9.99984 6.66667ZM8.95817 12.5C8.95817 11.9247 9.42454 11.4583 9.99984 11.4583C10.5751 11.4583 11.0415 11.9247 11.0415 12.5C11.0415 13.0753 10.5751 13.5417 9.99984 13.5417C9.42454 13.5417 8.95817 13.0753 8.95817 12.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default WarningFull
